export interface SvgIconsProps {
    className?: string,
};

const Star = (props: SvgIconsProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M4.98915 4.51749C4.97484 4.55311 4.94141 4.5774 4.90311 4.58L2.44448 4.7467C2.35455 4.7528 2.31795 4.86542 2.38713 4.92322L4.27822 6.50324C4.30767 6.52785 4.32044 6.56715 4.31108 6.60437L3.70987 8.99419C3.68787 9.08161 3.78367 9.15121 3.86002 9.10328L5.94708 7.793C5.97959 7.77259 6.02091 7.77259 6.05342 7.793L8.14049 9.10328C8.21683 9.15121 8.31263 9.08161 8.29064 8.99419L7.68943 6.60437C7.68006 6.56715 7.69283 6.52785 7.72229 6.50324L9.61338 4.92322C9.68255 4.86542 9.64596 4.7528 9.55603 4.7467L7.09739 4.58C7.0591 4.5774 7.02566 4.55311 7.01136 4.51749L6.09305 2.2307C6.05946 2.14706 5.94105 2.14706 5.90746 2.2307L4.98915 4.51749ZM7.72878 3.62051L7.02102 1.85806C6.65153 0.937943 5.34898 0.937936 4.97948 1.85806L4.27173 3.62051L2.37683 3.749C1.38757 3.81607 0.985052 5.05487 1.74596 5.69062L3.20344 6.90836L2.74008 8.75022C2.49818 9.71179 3.55196 10.4774 4.39172 9.95021L6.00025 8.94036L7.60878 9.95021C8.44854 10.4774 9.50233 9.7118 9.26042 8.75022L8.79706 6.90836L10.2545 5.69062C11.0154 5.05488 10.6129 3.81607 9.62368 3.749L7.72878 3.62051Z" fill="#FF5252"/>
    </svg>
);


const Histogramm = (props: SvgIconsProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M3 6.5V9.5" stroke="#FF5252"/>
        <path d="M6 4.5V9.5" stroke="#FF5252"/>
        <path d="M9 2.5V9.5" stroke="#FF5252"/>
    </svg>
);

const CircleYellowBg = (props: SvgIconsProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="6" cy="6" r="3.5" fill="#FFC107" stroke="#FF5252"/>
    </svg>
);

const CircleUpStick = (props: SvgIconsProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="8.5" y="5.5" width="5" height="5" rx="2.5" transform="rotate(90 8.5 5.5)" stroke="#FF5252"/>
        <rect x="6.5" y="1.5" width="1" height="1" rx="0.5" transform="rotate(90 6.5 1.5)" fill="white" stroke="#FF5252"/>
        <path d="M6 2.5V5.5" stroke="#FF5252"/>
    </svg>
);

const CircleUpStickLeft = (props: SvgIconsProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="5.5" y="3.5" width="5" height="5" rx="2.5" stroke="#FF5252"/>
        <rect x="1.5" y="5.5" width="1" height="1" rx="0.5" fill="white" stroke="#FF5252"/>
        <path d="M2.5 6L5.5 6" stroke="#FF5252"/>
    </svg>
);

const CircleStickInside = (props: SvgIconsProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="6" cy="6" r="3.5" stroke="#FF5252"/>
        <path d="M6 8L6 4" stroke="#FF5252"/>
    </svg>
);

const SquareDiamond = (props: SvgIconsProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.10202 3.17157L3.27359 6L6.10202 8.82843L8.93044 6L6.10202 3.17157ZM2.56648 5.29289C2.17596 5.68342 2.17596 6.31658 2.56648 6.70711L5.39491 9.53553C5.78543 9.92606 6.4186 9.92606 6.80912 9.53553L9.63755 6.70711C10.0281 6.31658 10.0281 5.68342 9.63755 5.29289L6.80912 2.46447C6.4186 2.07394 5.78543 2.07394 5.39491 2.46447L2.56648 5.29289Z" fill="#FF5252"/>
    </svg>
);


// {
//     { -1, defaultIconName },
//     { 0 , QStringLiteral("circle_with_up_stick.svg") },
//     { 1 , QStringLiteral("star.svg") },
//     { 2 , QStringLiteral("square_diamond.svg") },
//     { 3 , QStringLiteral("circle_with_yellow_background.svg") },
//     { 4 , QStringLiteral("histogramm.svg") },
//     { 5 , QStringLiteral("circle_with_stick_inside.svg") },
//     { 6 , QStringLiteral("circle_with_stick_on_left.svg") },
// };

export const gtmTypeIcons = new Map<number, (props: SvgIconsProps) => JSX.Element>([
    [-1, SquareDiamond],
    [0, CircleUpStick],
    [1, Star],
    [2, SquareDiamond],
    [3, CircleYellowBg],
    [4, Histogramm],
    [5, CircleStickInside],
    [6, CircleUpStickLeft],
])

